import { Component, Input, OnInit, TemplateRef, ViewChild, ElementRef } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { take } from "rxjs/operators";
import { CustomEventService } from "@shared/services/custom-event.service";
import { WidgetService } from "@shared/services/widget.service";
import { WidgetStatePlaceholderEnum } from "@shared/enums/widget-state-placeholder.enum";
import ActionTypesEnum from "@shared/enums/action-constant.enum";


@UntilDestroy()
@Component({
  selector: 'fortify-widget',
  templateUrl: './fortify-widget.component.html'
})
export class FortifyWidgetComponent implements OnInit {

  @Input() dateFilterable: boolean;
  @ViewChild('toolTipTitle') toolTipTitle: TemplateRef<any>;
  @Input() parent : HTMLElement;
  toolTipHTML: string;
  initialLoading: boolean;
  widgetId: string;
  widgetName: string;
  selectedDate: any;
  loadingByDate: boolean;
  showDownloadIcon: boolean;
  url: string;
  note: string;
  headerAddon: string;
  widgetStatePlaceholderEnum = WidgetStatePlaceholderEnum;
  showWidgetStatePlaceholder: WidgetStatePlaceholderEnum;
  loading: boolean;
  widgetFooter: Widget.FooterModel;

  fortifyProjects: any;
  totalProjectCount: any;
  headerInfoItems: any;
  projectsFortify: any;
  projectsNumber: number;
  displayfortifyProjects: any;
  listOfName: any[];
  projectName: any;
  searchValueName = '';
  sortValueSonar: any;
  withoutProjectName: any;
  PAGE_SIZE = 10;
  headerInfoItemsForFrist: any;
  cardInfoItems: any;
  deltaValueUp: boolean;
  selectedTooltips: any[];
  isModalVisible: boolean;
  tooltipContent: any[];
  originalProjectsFortify: any[];
  codeQualityMetricsData: any[];

  constructor(private customEventService: CustomEventService,
              private widgetService: WidgetService,
              public elementRef: ElementRef) {
  }
  ngOnInit() {

    this.loadWidgetData(true);
    this.customEventService.eventAnnounced$.pipe(
      untilDestroyed(this)
    ).subscribe(({ action, data }) => {
      if (action === ActionTypesEnum.UPDATE_WIDGET_DATA) {
        this.loadWidgetData();
      }

      if (action === ActionTypesEnum.UPDATE_WIDGET_DATE) {
        const { id, date } = data;

        if (this.widgetId === id ) {
          this.selectedDate = date;
          this.loadWidgetData();
        }
      }

    });

}

  loadWidgetData(initial?: boolean): void {
    this.loading = true;
    this.initialLoading = true;
    this.widgetService.get(this.widgetId, this.selectedDate)
      .pipe(untilDestroyed(this), take(1))
      .subscribe(
        (response) => {
          if (!response.data || response.data.length === 0) {
            this.showWidgetStatePlaceholder = this.widgetStatePlaceholderEnum.DATA_NOT_FOUND;
            this.loading = false;
            this.initialLoading = false;
            return;
          }
          this.originalProjectsFortify = response?.data?.projects;
          this.codeQualityMetricsData = this.originalProjectsFortify[0].statistics
          this.codeQualityMetricsData.forEach(value => {
            this.deltaValueUp = value.deltaValueUp;
          })

          this.fortifyProjects = response?.data;
          this.projectsFortify = [...this.originalProjectsFortify];
          this.displayfortifyProjects = this.projectsFortify;
          this.totalProjectCount = this.fortifyProjects.headerInfo.totalProjectCount;
          this.headerInfoItems = this.fortifyProjects.headerInfo.headerInfoItems;
          this.cardInfoItems = this.fortifyProjects.card;
          this.headerInfoItemsForFrist = this.headerInfoItems[0].issueTypeDisplay;
          this.projectsNumber = this.projectsFortify.length;
          this.projectName = this.headerInfoItems[0];
          this.withoutProjectName = this.widgetName === 'Fortify Project(s)'
              ? this.headerInfoItems
              : this.headerInfoItems.slice(1);
          this.listOfName = this.originalProjectsFortify.map((project) => ({
            text: project.name,
            value: project.name,
            selected: false,
          }));

          this.loading = false;
          this.initialLoading = false;
        },
        (error) => {
          this.initialLoading = false;
          this.loading = false;
        }
      );
  }

  trueFalseSortFn = (a: any, b: any): number => {
    const valueA = a.statistics.find(stat => stat.type.startsWith('QUALITY_GATE'))?.valueDisplay || '';
    const valueB = b.statistics.find(stat => stat.type.startsWith('QUALITY_GATE'))?.valueDisplay || '';
    if (valueA === 'Failed' && valueB === 'Passed') {
      return -1;
    } else if (valueA === 'Passed' && valueB === 'Failed') {
      return 1;
    }
    return 0;
  };

  sonarFilterChange(selectedFilters: string[]): void {
    this.listOfName.forEach((filter) => {
      filter.selected = selectedFilters.includes(filter.text);
    });
    if(selectedFilters.length) {
      this.searchSonar();
    } else {
      this.loadWidgetData();
    }


  }

  sortSonarTable(key: string, sortOrder: string): void {
    this.sortValueSonar = { key, value: sortOrder };
    this.searchSonar();
  }

  searchSonar(): void {
    const fullData = { ...this.fortifyProjects };
    let filteredProjects = [...this.originalProjectsFortify];

    if (this.listOfName.some((filter) => filter.selected)) {
      filteredProjects = filteredProjects.filter((project) =>
        this.listOfName.some(
          (filter) => filter.selected && project.name === filter.text
        )
      );
    }
    if (this.sortValueSonar?.key && this.sortValueSonar?.value) {
      filteredProjects = filteredProjects.sort((a, b) => {
        const aValue =
          a.statistics.find((stat) => stat.type === this.sortValueSonar.key)?.value || 0;
        const bValue =
          b.statistics.find((stat) => stat.type === this.sortValueSonar.key)?.value || 0;
        return this.sortValueSonar.value === 'ascend' ? aValue - bValue : bValue - aValue;
      });
    }
    this.displayfortifyProjects = filteredProjects;
    this.fortifyProjects = {
      ...fullData,
      projects: filteredProjects,
    };
    this.displayfortifyProjects = filteredProjects;
  }

  setTooltipContent(tooltips: any[]): void {
    this.tooltipContent = tooltips;
  }

  public formatStatValue(value: number): string {
    if (value >= 1_000_000) {
      return `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
    } else if (value >= 1000) {
      return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}k`;
    } else {
      return value?.toString();
    }
  }


  openModal(tooltips: any[]): void {
    this.selectedTooltips = tooltips;
    this.isModalVisible = true;
  }

  handleOk(): void {
    this.isModalVisible = false;
  }

  handleCancel(): void {
    this.isModalVisible = false;
  }

  }
